import { render, staticRenderFns } from "./searchResult.vue?vue&type=template&id=9f38b4fc&scoped=true&"
import script from "./searchResult.vue?vue&type=script&lang=js&"
export * from "./searchResult.vue?vue&type=script&lang=js&"
import style0 from "./searchResult.vue?vue&type=style&index=0&id=9f38b4fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f38b4fc",
  null
  
)

export default component.exports